/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FIND_ASSIGNABLE_ASSETS_FOR_ACCOUNT,
  SortDirectionEnum,
} from '@gripp/shared-logic';
import { AssignmentListGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAccountAssetColumns } from './useAccountAssetColumns';

type EditAccountAssetsListProps = {
  accountId: string;
  workspaceId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const EditAccountAssetsList = ({
  accountId,
  workspaceId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: EditAccountAssetsListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => ({
    accountId,
    workspaceId,
    keyword,
  }));
  const columns = useAccountAssetColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({ accountId, workspaceId, keyword });
  }, [accountId, workspaceId, keyword]);

  return (
    <AssignmentListGrid
      modelName="asset"
      query={FIND_ASSIGNABLE_ASSETS_FOR_ACCOUNT}
      dataPrefix="asset.findAssignableAssetsForAccount"
      columns={columns}
      filter={filter}
      assignments={assignments}
      onAssignmentsChange={updateAssignments}
      maxHeight={maxHeight}
      textEmpty={t('assets.textEmpty')}
      orderBy={{ field: 'name', order: SortDirectionEnum.Asc }}
      // Assets assigned via a group show checked but stay read-only here —
      // this modal edits direct assignments only.
      isRowForceSelected={(row) => row.isGroupAssigned}
    />
  );
};
